import {Typography} from '@mui/material';

/**
 * Function to generate content for the Terms of Service page.
 *
 * @param {boolean} isPage - A boolean indicating whether the content is for a standalone page.
 * @returns {JSX.Element} The rendered content for the Terms of Service page.
 */
export const TermsOfServiceContent = isPage => {
  return (
    <>
      <Typography variant={isPage ? 'subtitle1' : 'body2'} sx={{marginTop: 2}}>
        Welcome to our online symptom checker app, AI-MD ("App"). By using our App, you agree to be bound by the
        following terms and conditions ("Terms of Service Agreement" or "Agreement"). Please read this Agreement
        carefully before using the App. If you do not agree with any of these terms and conditions, do not use the App.
      </Typography>
      <Typography variant={isPage ? 'h6' : 'subtitle2'} sx={{marginTop: 2}}>
        DESCRIPTION OF SERVICE
      </Typography>
      <Typography variant={isPage ? 'subtitle1' : 'body2'}>
        Our App is a tool designed to help you check your symptoms and provide guidance on potential health issues. The
        App is not intended to be a substitute for professional medical advice, diagnosis, or treatment. Always seek the
        advice of a qualified healthcare provider with any questions you may have regarding a medical condition.
      </Typography>
      <Typography variant={isPage ? 'h6' : 'subtitle2'} sx={{marginTop: 2}}>
        YOUR USE OF THE APP
      </Typography>
      <Typography variant={isPage ? 'subtitle1' : 'body2'}>
        You agree to use the App only for its intended purposes and in accordance with this Agreement. You agree not to
        use the App for any unlawful purpose or in any manner that could damage, disable, overburden, or impair the App.
      </Typography>
      <Typography variant={isPage ? 'h6' : 'subtitle2'} sx={{marginTop: 2}}>
        DISCLAIMER OF WARRANTIES
      </Typography>
      <Typography variant={isPage ? 'subtitle1' : 'body2'}>
        The App is provided on an "as is" basis without any warranties of any kind, either express or implied, including
        but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement of
        intellectual property. We do not warrant that the App will be error-free or uninterrupted, or that the results
        obtained from the use of the App will be accurate or reliable.
      </Typography>
      <Typography variant={isPage ? 'h6' : 'subtitle2'} sx={{marginTop: 2}}>
        LIMITATION OF LIABILITY
      </Typography>
      <Typography variant={isPage ? 'subtitle1' : 'body2'}>
        To the maximum extent permitted by law, we shall not be liable for any direct, indirect, incidental, special, or
        consequential damages arising out of or in connection with your use of the App. This includes but is not limited
        to damages for loss of profits, goodwill, use, data, or other intangible losses resulting from (i) the use or
        inability to use the App, (ii) the cost of procurement of substitute goods and services resulting from any
        goods, data, information, or services purchased or obtained or messages received or transactions entered into
        through or from the App, (iii) unauthorized access to or alteration of your transmissions or data, (iv)
        statements or conduct of any third party on the App, or (v) any other matter relating to the App.
      </Typography>
      <Typography variant={isPage ? 'h6' : 'subtitle2'} sx={{marginTop: 2}}>
        INDEMNIFICATION
      </Typography>
      <Typography variant={isPage ? 'subtitle1' : 'body2'}>
        You agree to indemnify and hold harmless us, our affiliates, officers, agents, and employees from any claim,
        demand, or damage, including reasonable attorneys' fees, arising out of or in connection with your use of the
        App or any violation of this Agreement.
      </Typography>
      <Typography variant={isPage ? 'h6' : 'subtitle2'} sx={{marginTop: 2}}>
        MODIFICATIONS TO THE AGREEMENT
      </Typography>
      <Typography variant={isPage ? 'subtitle1' : 'body2'}>
        We reserve the right to modify this Agreement at any time without notice to you. Your continued use of the App
        after any such modification shall constitute your acceptance of the modified Agreement.
      </Typography>
      <Typography variant={isPage ? 'h6' : 'subtitle2'} sx={{marginTop: 2}}>
        GOVERNING LAW
      </Typography>
      <Typography variant={isPage ? 'subtitle1' : 'body2'}>
        This Agreement shall be governed by and construed in accordance with the laws of the jurisdiction in which we
        are located.
      </Typography>
      <Typography variant={isPage ? 'h6' : 'subtitle2'} sx={{marginTop: 2}}>
        ENTIRE AGREEMENT
      </Typography>
      <Typography variant={isPage ? 'subtitle1' : 'body2'}>
        This Agreement constitutes the entire agreement between you and us with respect to the use of the App and
        supersedes all prior or contemporaneous communications and proposals, whether oral or written, between you and
        us.
      </Typography>
      <Typography variant={isPage ? 'h6' : 'subtitle2'} sx={{marginTop: 2}}>
        CONTACT INFORMATION
      </Typography>
      <Typography variant={isPage ? 'subtitle1' : 'body2'}>
        If you have any questions or concerns about this Agreement or the App, please contact us at info@ai-md.com.
      </Typography>
    </>
  );
};
